<template>
  <router-view />
</template>

<script>
import { mapState, mapActions } from "vuex";
import toastr from "toastr";
import { firestoreDB } from "./assets/js/firebase";
import { HTTP } from "./assets/js/axiosConfig";
import logoutAction from "./assets/js/mixins";
import firebaseMixins from "./assets/js/firebaseMixins";

const SESSION_TIMER = 1740000; // in ms
let sessionInterval;

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export default {
  name: "App",
  mixins: [logoutAction, firebaseMixins],
  data() {
    return {
      snapshotCruds: null,
    };
  },
  computed: {
    ...mapState({
      sessionUser: (store) => store.sessionUser,
      firebaseSignin: (store) => store.firebaseSignin,
      labels: (store) => store.labels,
      cruds: (store) => store.crudData.cruds,
      cmsResources: (store) => store.crudData.cmsResources,
    }),
  },
  watch: {
    sessionUser(value) {
      if (value && this.firebaseSignin) {
        console.log("sessionUser getRessources");
        this.getRessources();
      } else if (!value) {
        console.log("sessionUser clearTimeouts 11");
        this.clearTimeouts();
        this.firebaseAuthSignout();
      }
    },
    firebaseSignin(value) {
      console.log("firebaseSignin in", value);
      if (value && this.sessionUser) {
        console.log("firebaseSignin", value);
        this.getRessources();
      } else if (!value && this.snapshotCruds) {
        this.detacheListenerSnapshot();
      }
    },
  },
  methods: {
    ...mapActions([
      "setUserInfo",
      "getCRUDs",
      "generalSegmentationsFirebaseListener",
      "getFirestoreRecords",
    ]),
    getRessources() {
      this.getAllCRUDData();
      this.initialiseFirestoreListener();
      this.generalSegmentationsFirebaseListener();
    },
    initialiseFirestoreListener() {
      const my = this;
      console.log("start listening");
      this.snapshotCruds = firestoreDB
        .collection(`resources_${process.env.ENV_SHORTNAME}`)
        .onSnapshot(
          (snapshot) => {
            console.log("listening");
            if (my.sessionUser) {
              snapshot.docChanges().forEach((change) => {
                const docData = change.doc.data();
                // Call the get resource request
                my.getCRUDs(docData.name);
                // If cms resource should call GET to refresh list
                my.getFirestoreRecords(docData.name);

                // If doc.action === 'delete' trigger toastr notification
                if (docData.action === "delete") {
                  my.$store.dispatch("setDeletedResource", docData);
                  my.triggerToastAlert(docData);
                  // Delete the "action" field from document to avoid repeat notifications
                  setTimeout(() => {
                    my.deleteFirestoreDoc(docData.name);
                  }, 500);
                }
              });
            }
          },
          (error) => {
            console.log("error 1001", error);
          }
        );
    },
    getAllCRUDData() {
      // Get ALL Resources
      const resourceList = Object.keys(this.cruds);
      const externalResourceList = Object.keys(this.cmsResources);
      resourceList.forEach((resource) => {
        this.getCRUDs(resource);
      });

      externalResourceList.forEach((resource) => {
        this.getFirestoreRecords(resource);
      });
    },
    triggerToastAlert(record) {
      const my = this;
      toastr.warning(
        `${
          this.labels.resources[record.name]
        } : ${record.itemName.toUpperCase()} ${my.labels.deleted}`
      );
    },
    deleteFirestoreDoc(docName) {
      firestoreDB
        .collection(`resources_${process.env.ENV_SHORTNAME}`)
        .doc(docName)
        .set(
          {
            action: "",
          },
          { merge: true }
        )
        .catch((error) =>
          console.log(`error deleting doc : ${docName}`, error)
        );
    },
    activityListener() {
      const my = this;
      // We send a request to backend to check the users session status every 5 mins
      my.checkUserSession();
      clearTimeout(sessionInterval);
      sessionInterval = setTimeout(() => {
        my.activityListener();
      }, SESSION_TIMER);
    },
    checkUserSession() {
      if (this.sessionUser) {
        HTTP.get(`api/login/user/email/${this.sessionUser.email}`).catch(
          (err) => {
            // If not logged user redirect
            this.logoutAction();
            this.clearTimeouts();
            // Handle Errors here.
            this.firebaseAuthSignout();
          }
        );
      } else {
        this.logoutAction();
        this.clearTimeouts();
      }
    },
    clearTimeouts() {
      clearTimeout(sessionInterval);
    },
    startTimeouts() {
      this.checkUserSession();
    },
    handleVisibilityChange(hidden) {
      if (document[hidden]) {
        this.clearTimeouts();
      } else {
        this.startTimeouts();
      }
    },
    detacheListenerSnapshot() {
      console.log("stopping listener");
      if (this.snapshotCruds) {
        this.snapshotCruds();
        console.log("stopped listener");
        this.snapshotCruds = null;
      }
    },
    checkCustomDomain() {
      if (location.origin !== process.env.DOMAIN) {
        location.href = process.env.DOMAIN;
      }
    },
  },
  mounted() {
    this.checkCustomDomain();
    // check if connected
    this.authStateChanged();
    this.activityListener();
    // Set the name of the hidden property and the change event for visibility
    let hidden;
    let visibilityChange;
    if (typeof document.hidden !== "undefined") {
      // Opera 12.10 and Firefox 18 and later support
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    }

    if (
      typeof document.addEventListener === "undefined" ||
      hidden === undefined
    ) {
      console.log(
        "This demo requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API."
      );
    } else {
      // Handle page visibility change
      const my = this;
      document.addEventListener(visibilityChange, () => {
        my.handleVisibilityChange(hidden);
      });
    }
  },
  beforeDestroy() {
    this.clearTimeouts();
    this.detacheListenerSnapshot();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue